import {
	BLOCK_TEMPLATES_SECTION,
	DATA_AND_CHARTS_SECTION,
	EMBED_SECTION,
	MEDIA_SECTION,
	MENU,
	OTHER_SECTION,
	RECOMMENDED_SECTION,
	ROVO_SECTION,
	STRUCTURE_SECTION,
	TEXT_FORMATTING_SECTION,
} from '@atlaskit/editor-common/quick-insert/keys';
import { QUICK_INSERT_MENU_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { RegisterComponent } from '@atlaskit/editor-ui-control-model/types';

const sections = [
	RECOMMENDED_SECTION,
	STRUCTURE_SECTION,
	MEDIA_SECTION,
	EMBED_SECTION,
	TEXT_FORMATTING_SECTION,
	ROVO_SECTION,
	DATA_AND_CHARTS_SECTION,
	BLOCK_TEMPLATES_SECTION,
	OTHER_SECTION,
] as const;

export const getQuickInsertComponents = (): RegisterComponent[] => [
	MENU,
	...sections.map((section) => ({
		...section,
		parents: [
			{
				...MENU,
				rank: QUICK_INSERT_MENU_RANK[section.key],
			},
		],
	})),
];
